"use strict";

exports.__esModule = true;
exports.CreditCardClient = void 0;
var _http = require("@tajawal/web-core-sdk-v2/lib/services/http.service");
var _client = require("@tajawal/web-core-sdk-v2/lib/utils/client.utils");
var _constants = require("../constants");
const CreditCardClient = {
  /**
   *
   * @returns {Promise}
   *
   * @description save credit card
   */
  saveCreditCard(data) {
    const requestId = 'SAVE_CREDIT_CARD';
    const endPoint = _constants.ENDPOINTS.CREDIT_CARD;
    return _http.$http.post(requestId, endPoint, {
      data
    }).then(({
      data
    }) => data);
  },
  /**
   *
   * @returns {Promise}
   *
   * @description update credit card
   */
  updateCreditCard({
    instrumentId,
    data
  }) {
    const requestId = 'UPDATE_CREDIT_CARD';
    const endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.UPDATE_DELETE_CREDIT_CARD, {
      instrumentId
    });
    return _http.$http.patch(requestId, endPoint, {
      data,
      headers: {
        'x-captcha-token': data.captchaToken // 'TestCaptchaTokenForDevAndStaging' // TODO remove this
      }
    }).then(({
      data
    }) => data);
  },
  /**
   *
   * @returns {Promise}
   *
   * @description get credit card
   */
  getCreditCards() {
    const requestId = 'GET_CREDIT_CARDS';
    const endPoint = _constants.ENDPOINTS.CREDIT_CARD;
    return _http.$http.get(requestId, endPoint).then(({
      data
    }) => data);
  },
  /**
   *
   * @returns {Promise}
   *
   * @description delete credit card
   */
  deleteCreditCards(instrumentId) {
    const requestId = 'DELETE_CREDIT_CARDS';
    const endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.UPDATE_DELETE_CREDIT_CARD, {
      instrumentId
    });
    return _http.$http.delete(requestId, endPoint).then(({
      data
    }) => data);
  }
};
exports.CreditCardClient = CreditCardClient;